const ensureLeadingSlash = (text: string): string =>
  text.startsWith("/") ? text : `/${text}`;

export default ensureLeadingSlash;
